import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth token lives in an httpOnly cookie set by the backend.
// This flag is only a non-sensitive UI hint (e.g. skip analytics tracking for admin).
const ADMIN_HINT_KEY = "wve_admin";

export const auth = {
  markAdmin() {
    localStorage.setItem(ADMIN_HINT_KEY, "1");
  },
  clearAdmin() {
    localStorage.removeItem(ADMIN_HINT_KEY);
  },
  isAdminHint() {
    return localStorage.getItem(ADMIN_HINT_KEY) === "1";
  },
};

const client = axios.create({ baseURL: API, withCredentials: true });

export default client;
